import axios from "axios";

const baseURL = process.env.VUE_APP_BASE_URL || "https://api.gapo.qzz.io/";

const client = axios.create({
  baseURL: baseURL
});

// ?lang= in query (not header): backend API cache keys include the query
// but not headers, so per-language responses stay correctly cached.
client.interceptors.request.use(function (config) {
  config.params = Object.assign({ lang: localStorage.getItem("selectedLanguage") || "en" }, config.params);
  return config;
});

function normalizePath(path) {
  let clean = path.startsWith("/") ? path.slice(1) : path;
  return clean.startsWith("api/") ? clean : "api/" + clean;
}

export function apiGet(path, config) {
  return client.get(normalizePath(path), config);
}

export function apiPost(path, body, config) {
  return client.post(normalizePath(path), body, config);
}

export function apiPut(path, body, config) {
  return client.put(normalizePath(path), body, config);
}

export default client;
